import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import './i18n';
import App from './app/app';
import { AppErrorBoundary } from './components/app-error-boundary';
import { authenticationSession } from './lib/authentication-session';
import { sentry } from './lib/sentry';

sentry.init();
authenticationSession.restoreSentryUser();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
